import cx from "classnames";

import { EmptystateCodeFileColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

import styles from "./styles.module.css";

type SpaceliftVcsRepoBinaryFilePlaceholderProps = {
  fileType?: string;
  bordered?: boolean;
};

const FALLBACK_CAPTION = "Cannot be displayed in editor";

const SpaceliftVcsRepoBinaryFilePlaceholder = ({
  fileType,
  bordered,
}: SpaceliftVcsRepoBinaryFilePlaceholderProps) => {
  return (
    <EmptyState
      icon={EmptystateCodeFileColored}
      caption={fileType ? `${fileType} - cannot be displayed in editor` : FALLBACK_CAPTION}
      className={cx(styles.wrapper, bordered && styles.bordered)}
    />
  );
};

export default SpaceliftVcsRepoBinaryFilePlaceholder;
